module.exports = __webpack_public_path__ + "static/media/decryption-button.3a72c61f.svg";